import React from 'react'
import Slider from 'react-slick'
import Image from '../Image'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import {
  imageCarouselContainer,
  imageCarouselSingleImage,
  slick,
} from './index.module.css'

const ImageCarousel = ({ images }) => {
  const imageCarouselImages = images ? images : []

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <div className={'wrapper'}>
      <div
        className={[imageCarouselContainer, 'imageCarouselSlickContainer'].join(
          ' '
        )}
      >
        {imageCarouselImages.length > 1 ? (
          <Slider className={[slick, 'slick'].join(' ')} {...settings}>
            {imageCarouselImages.map((image, idx) => (
              <div key={idx}>
                <Image
                  objectFit="contain"
                  source={image}
                  imageStyles={{
                    objectFit: 'contain',
                    objectPosition: 'center',
                  }}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <div className={imageCarouselSingleImage}>
            <Image
              objectFit="contain"
              source={imageCarouselImages[0]}
              imageStyles={{
                objectFit: 'contain',
                objectPosition: 'center',
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ImageCarousel
